import { styled } from "@mui/material/styles";
import { IoIosArrowForward } from "react-icons/io";
import { Fragment, useEffect, useState } from "react";
import { Grid, Paper, Box, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import { useAxios } from "../../hooks";
import pages from "../../constants/pages";

function OutingPassListPage() {
  const axiosDigipass = useAxios({
    baseURL: "digipass",
  });
  const navigate = useNavigate();

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  let type = queryParams.get("type");
  let campusID = queryParams.get("campusID");

  const [gatePassConfigList, setGatePassConfigList] = useState([]);

  useEffect(() => {
    axiosDigipass({
      url:
        "/attendance/gate-pass/gate-pass-config-list?premises_id=" +
        campusID +
        "&gate_pass_type=" +
        type,
      method: "GET",
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        let arr = [...response.data];

        type == "entry" &&
          arr.push({
            campus_id: campusID,
            text1: "consent 1",
            text2: "consent2",
            format_name: "Custom Pass",
            gate_pass_type: "Entry",
          });

        setGatePassConfigList(arr);
      }
    });
  }, []);

  return (
    <Fragment>
      <Grid container justifyContent={"center"}>
        <Grid
          item
          container
          sx={{ "@media (min-width:900px)": { width: "50%" } }}
        >
          <Grid
            container
            spacing={3}
            sx={{ background: "white", padding: "10px" }}
          >
            <Grid
              item
              container
              sx={{
                padding: "10px !important",
              }}
            >
              <Grid item container justifyContent="center" mb={1}>
                <Typography
                  fontSize="19px"
                  fontWeight="900"
                  color="black"
                  sx={{ "-webkit-text-stroke-width": "0.5px" }}
                >
                  Select Gate Pass{" "}
                </Typography>
                <Typography
                  fontSize="14px"
                  fontWeight="600"
                  color="#a1a1a1"
                  sx={{ textAlign: "center" }}
                >
                  Choose your outing pass to request permission for exit.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {gatePassConfigList.map((item, index) => {
            return (
              <Grid
                container
                spacing={3}
                sx={{
                  borderRadius: "10px",
                  background: "white",
                  padding: "10px",
                }}
                onClick={() => {}}
              >
                <Grid
                  item
                  container
                  sx={{
                    border: "0.6px solid #0000001A",
                    borderRadius: "10px",
                    padding: "10px !important",
                    backgroundColor: "#ffd0d0",
                    backgroundImage:
                      "linear-gradient(164deg, rgb(232 232 255) 3%, rgb(255, 255, 255) 31%)",
                    margin: "10px",
                  }}
                  spacing={2}
                >
                  <Grid item xs={12} justifyContent="start" mb={1}>
                    <Typography
                      fontSize="14px"
                      fontWeight="700"
                      color="#00000080"
                      sx={{ "-webkit-text-stroke-width": "0.5px" }}
                    >
                      {item.config_name?.toUpperCase() || "OUTING PASS"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} justifyContent="start" mb={1}>
                    <Typography
                      fontSize="14px"
                      fontWeight="500"
                      color="rgb(135 135 135 / 90%)"
                      sx={{ "-webkit-text-stroke-width": "0.15px" }}
                    >
                      {item.text1}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      borderRadius: "7.5px",
                      padding: "7px 0px",
                      paddingLeft: "0px !important",
                      alignSelf: "end",
                    }}
                    onClick={() => {
                      navigate(
                        pages.OutingPage.route +
                          "?type=" +
                          type +
                          "&campusID=" +
                          campusID +
                          "&passid=" +
                          item._id
                      );
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: "rgb(57, 54, 239)",
                        padding: "7px",
                        fontWeight: 900,
                        borderRadius: "7px",
                        background: "white",
                        border: "1px solid rgb(57, 54, 239)",
                      }}
                    >
                      Request Pass
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default OutingPassListPage;
